// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"352":"eb3a9abf","594":"827a31ce","856":"a021d77f"}[chunkId] + ".js";
};